import { render, staticRenderFns } from "./UserPermissionCell.vue?vue&type=template&id=1d531fa6&scoped=true&"
import script from "./UserPermissionCell.vue?vue&type=script&lang=js&"
export * from "./UserPermissionCell.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissionCell.vue?vue&type=style&index=0&id=1d531fa6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d531fa6",
  null
  
)

export default component.exports